@if (isFooterBtn) {
  <button (click)="shareTrade()" class="btn btn-primary btn-inverse footer-btn" type="button">
    <span>{{ "share_this_trade_button_title" | translate }}</span>
  </button>
} @else {
  <button (click)="shareTrade()" class="btn btn-primary share-list-item-btn" type="button">
    <svg-inline
      class="icon-status-forward share-icon"
      src="assets/images/icons/icon-share.svg"
      [alt]="'forward_alt_text' | translate" />
    <span>{{ "share_trade_label" | translate }}</span>
  </button>
}

